import React, { useState, useEffect } from "react";
import { putTransporte as modifTransporte } from "../helpers/rutaTransportes";
import { getLocalidades } from "../helpers/rutaLocalidades";
import { Modal, Button } from "react-bootstrap";
import "animate.css";

const ModalFormTransporte = ({ transporte, handleClose, show }) => {
  const [showSuccess, setShowSuccess] = useState(false);

  // Campos correctos para TRANSPORTE
  const [formValues, setFormValues] = useState({
    transporte: "",
    domicilio: "",
    telefono: "",
    cuit: "",
    email: "",
    localidad: "", // ObjectId
  });

  // Cargar valores iniciales del transporte seleccionado
  useEffect(() => {
    if (transporte && transporte._id) {
      const localidadId =
        typeof transporte.localidad === "object"
          ? transporte.localidad?._id
          : transporte.localidad;

      setFormValues({
        transporte: transporte.transporte ?? "",
        domicilio: transporte.domicilio ?? "",
        telefono: transporte.telefono ?? "",
        cuit: transporte.cuit ?? "",
        email: transporte.email ?? "",
        localidad: localidadId ?? "",
      });
    }
  }, [transporte]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((s) => ({ ...s, [name]: value }));
  };

  // Enviar PUT con payload limpio
  const handleSubmit = async (e) => {
    e.preventDefault();

    // sanitizar: trim y quitar vacíos
    const clean = Object.fromEntries(
      Object.entries(formValues).map(([k, v]) => [k, typeof v === "string" ? v.trim() : v])
    );
    if (!clean.localidad) delete clean.localidad; // evita "" en ObjectId

    try {
      const resp = await modifTransporte(transporte._id, clean);
      // si tu back devuelve {ok:false,...} con 200:
      if (resp?.ok === false) throw { response: { data: resp } };

      setShowSuccess(true);
      setTimeout(() => {
        setShowSuccess(false);
        handleClose(); // recarga tabla en el padre
      }, 1200);
    } catch (error) {
      const d = error?.response?.data;
      console.error("❌ Error al actualizar transporte:", d || error);
      const msg =
        d?.error?.message ||
        d?.err?.message ||
        d?.message ||
        (typeof d === "string" ? d : "") ||
        "No se pudo actualizar el transporte.";
      alert(msg);
    }
  };

  // -------- Localidades --------
  const [localidades, setLocalidades] = useState({ list: [], loading: true, error: "" });

  useEffect(() => {
    (async () => {
      try {
        const res = await getLocalidades();
        const list = Array.isArray(res?.localidades) ? res.localidades : [];
        setLocalidades({ list, loading: false, error: "" });
      } catch (e) {
        setLocalidades({ list: [], loading: false, error: e?.message || "Error al cargar localidades" });
      }
    })();
  }, []);

  if (!show) return null;

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Modificar Transporte</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="form-group mt-2">
              <label>Transporte</label>
              <input
                type="text"
                className="form-control"
                name="transporte"
                required
                value={formValues.transporte}
                onChange={handleChange}
              />
            </div>

            <div className="form-group mt-2">
              <label>Domicilio</label>
              <input
                type="text"
                className="form-control"
                name="domicilio"
                required
                value={formValues.domicilio}
                onChange={handleChange}
              />
            </div>

            <div className="form-group mt-2">
              <label>Teléfono</label>
              <input
                type="text"
                className="form-control"
                name="telefono"
                value={formValues.telefono}
                onChange={handleChange}
              />
            </div>

            <div className="form-group mt-2">
              <label>CUIT</label>
              <input
                type="text"
                className="form-control"
                name="cuit"
                value={formValues.cuit}
                onChange={handleChange}
              />
            </div>

            <div className="form-group mt-2">
              <label>Email</label>
              <input
                type="email"
                className="form-control"
                name="email"
                value={formValues.email}
                onChange={handleChange}
              />
            </div>

            <div className="form-group mt-2">
              <label>Localidad</label>
              <select
                className="form-control"
                name="localidad"
                value={formValues.localidad}
                onChange={handleChange}
              >
                <option value="">Elija una opción</option>
                {[...(localidades.list || [])]
                  .sort((a, b) =>
                    (a.localidad || "").localeCompare(b.localidad || "", "es", { sensitivity: "base" })
                  )
                  .map((loc) => (
                    <option key={loc._id} value={loc._id}>
                      {loc.localidad}
                    </option>
                  ))}
              </select>
            </div>

          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cancelar
            </Button>
            <Button type="submit" variant="dark">
              Guardar
            </Button>
          </Modal.Footer>
        </form>
      </Modal>

      <Modal
        show={showSuccess}
        centered
        backdrop="static"
        keyboard={false}
        dialogClassName="animate__animated animate__fadeInDown"
      >
        <Modal.Body className="text-center">
          <div style={{ fontSize: "3rem" }}>🖐</div>
          <h5 className="mt-2">¡Cambios guardados correctamente!</h5>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalFormTransporte;
